import React, { Suspense, lazy } from 'react'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'
import { Paper } from '@material-ui/core'
import Loading from 'pages/Loading'
// lazy
const ReactRouter = lazy(() => import('components/ReactRouter'))
const PWAPrompt = lazy(() => import('react-ios-pwa-prompt'))

// https://colorhunt.co/palette/117601
const theme1 = {
    primary: {
        main: '#4ecca3',
    },
    secondary: {
        // main: '#276350',
        main: '#296D56',
    },
    borderColor: {
        // main: '#252525',
        main: '#000000',
    },
    error: {
        main: '#cc4e4e',
    },
    text: {
        primary: '#eeeeee',
    },
    background: {
        // paper: '#393e46',
        // paper: '#272b30',
        paper: '#17191c',
        // card: '#26292e',
        card: '#212326',
    },
    type: 'dark',
}

const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    palette: theme1,
})

function App() {
    return (
        <MuiThemeProvider theme={theme}>
            <Paper square>
                <div className="App h-screen">
                    <Suspense fallback={<Loading />}>
                        <ReactRouter />
                        <PWAPrompt />
                    </Suspense>
                </div>
            </Paper>
        </MuiThemeProvider>
    )
}

export default App
